import api from "./api";


// Update your get_all_quotations function to accept pagination parameters
export const get_all_quotations = async (params = {}) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.data_per_page) queryParams.append('data_per_page', params.data_per_page);
    if (params.search) queryParams.append('search', params.search);
    
    const queryString = queryParams.toString();
    const url = `/catering_info/get_all_quotations${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching quotations:', error);
    throw error;
  }
};

export const save_catering_quotations = async (data) => {
    try {
        const response = await api.post('catering_info/create_quotation', data);
        return response.data;
    }
    catch (error) {
        console.error(error)
        const errorMessage =
            error?.response?.data?.detail || // standard FastAPI field
            error?.response?.data?.message || // fallback if backend uses another key
            error.message 
        throw new Error(errorMessage)
    }
}

export const get_specific_quotation = async (quotation_id) => {
    try {
        const response = await api.get(`catering_info/get_quotation/${quotation_id}`);
        return response.data.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)

    }
}

export const update_catering_quotation = async (quotation_id, data) => {
    try {
        const response = await api.put(`catering_info/update_quotation_menu/${quotation_id}`, data);
        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)

    }
}


// Update your get_all_invoices function to accept pagination parameters
export const get_all_invoices = async (params = {}) => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.data_per_page) queryParams.append('data_per_page', params.data_per_page);
    if (params.search) queryParams.append('search', params.search);
    
    const queryString = queryParams.toString();
    const url = `/catering_info/get_all_invoices${queryString ? `?${queryString}` : ''}`;
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoices:', error);
    throw error;
  }
};


export const create_catering_invoice = async (data) => {
    try {
        const response = await api.post('catering_info/invoice/create_catering_invoice/', data);
        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}


export const download_catering_quotation = async (id) => {
    try {
        const response = await api.get(`catering_info/download_quotation_pdf/${id}`, {
            responseType: 'blob' // Important: set response type to blob
        });

        // Create a blob from the PDF data
        const blob = new Blob([response.data], { type: 'application/pdf' });

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `quotation_${id}.pdf`); // or get filename from headers
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);

        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error);

        // Handle error responses that might be in JSON format
        if (error.response?.data instanceof Blob) {
            const errorText = await error.response.data.text();
            try {
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.detail || "Error downloading PDF");
            } catch {
                throw new Error("Error downloading PDF");
            }
        }

        throw new Error(error?.response?.data?.detail || "Error downloading PDF");
    }
}


export const get_menu_items_for_specific_menu = async (id) => {
    try {
        const response = await api.get(`catering/admin/main-menus/${id}/details`);
        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}

export const download_catering_invoice = async (id) => {
    try {
        const response = await api.get(`catering_info/download_catering_invoice/${id}/`, {
            responseType: 'blob' // Important: set response type to blob
        });
        
        // Create a blob from the PDF data
        const blob = new Blob([response.data], { type: 'application/pdf' });
        
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${id}.pdf`); // or get filename from headers
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        
        return { success: true, message: "Invoice downloaded successfully" };
    }
    catch (error) {
        console.error("Error Occured => ", error);
        
        // Handle error responses that might be in JSON format
        if (error.response?.data instanceof Blob) {
            const errorText = await error.response.data.text();
            try {
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.detail || "Error downloading invoice");
            } catch {
                throw new Error("Error downloading invoice");
            }
        }
        
        throw new Error(error?.response?.data?.detail || "Error downloading invoice");
    }
}

export const send_catering_quotation_mail = async (id) => {
    try {
        const response = await api.post(`catering_info/send_quotation_mail/${id}`);
        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}

export const send_catering_invoice_mail = async (id) => {
    try {
        const response = await api.post(`catering_info/send_invoice_mail/${id}`);
        return response.data;
    }
    catch (error) {
        console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}


export const save_catering_quotation_manual_payment= async (payload) => {
    try {
        const response = await api.post(`catering_info/manual_payment/`, payload);
        return response.data;
    }
    catch (error) {
        // console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}


export const get_catering_quotation_manual_payments = async (id) => {
    try {
        const response = await api.get(`catering_info/get_manual_payment_details/${id}`);
        return response.data;
    }
    catch (error) {
        // console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}


export const get_specific_catering_quotation_manual_payment = async (id) => {
    try {
        const response = await api.get(`catering_info/get_specific_payment_manual_detail/${id}`);
        return response.data;
    }
    catch (error) {
        // console.error("Error Occured => ", error)
        throw new Error(error?.response?.data?.detail)
    }
}
